/**
 * `/conta`.
 *
 * "Sair" executa `clearUserScopedStorage` (`PWA §7.5`) **antes** de navegar: se a navegacao
 * acontecesse primeiro, um erro na purga deixaria dado do titular anterior no aparelho com a
 * tela ja dizendo que ele saiu.
 */
import { useApiClient } from '@farmacia/api-client/query';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState, type ReactNode } from 'react';

import { lerAmbiente } from '../app/ambiente.js';
import { useSessao } from '../app/sessao.jsx';
import { portasDePurgaDoNavegador } from '../pwa/armazenamento/portas.js';
import { clearUserScopedStorage } from '../pwa/armazenamento/purga.js';
import { Conta } from '../telas/Conta.jsx';

export const Route = createFileRoute('/conta')({ component: TelaDeConta });

function TelaDeConta(): ReactNode {
  const cliente = useApiClient();
  const navegar = useNavigate();
  const { temSessao, definirEstado } = useSessao();
  const [verPedidosOffline, setVerPedidosOffline] = useState(false);

  const sair = useMutation({
    mutationFn: async () => {
      await cliente.auth.logout();
      await clearUserScopedStorage('LOGOUT', portasDePurgaDoNavegador(cliente));
    },
    onSettled: () => {
      definirEstado('ANONIMA');
      void navegar({ to: '/' });
    },
  });

  return (
    <Conta
      autenticado={temSessao}
      buildId={lerAmbiente(import.meta.env).buildId}
      aoEntrar={() => void navegar({ to: '/entrar' })}
      aoSair={() => { sair.mutate(); }}
      saindo={sair.isPending}
      verPedidosOffline={verPedidosOffline}
      aoMudarVerPedidosOffline={setVerPedidosOffline}
    />
  );
}
